import { EDITOR_EXPANDED_PLAY_BODY_SELECTOR } from '../constants/editor'
import { getScrollTopBelowHeader } from '../utils/stickyHeader'

type ScrollTarget = Maybe<HTMLElement | { $el?: unknown }>

const resolveElement = (target: ScrollTarget) => {
  if (target instanceof HTMLElement) return target

  const element = target?.$el
  return element instanceof HTMLElement ? element : undefined
}

const collapsingHeightAbove = (element: HTMLElement) => {
  const body = document.querySelector(EDITOR_EXPANDED_PLAY_BODY_SELECTOR)
  if (!body) return 0

  const { height, top } = body.getBoundingClientRect()
  return top < element.getBoundingClientRect().top ? height : 0
}

export const useExpandableScroll = () => {
  const { scrollTop } = useScrollUtils()

  const scrollBelowHeader = (element: HTMLElement, collapsingHeight = 0) => {
    scrollTop(Math.max(0, getScrollTopBelowHeader(element) - collapsingHeight))
  }

  const scrollExpandedIntoView = async (target: ScrollTarget) => {
    await nextTick()

    const element = resolveElement(target)
    if (!element) return

    scrollBelowHeader(element)
  }

  const scrollExpandingPlayIntoView = (target: ScrollTarget) => {
    const element = resolveElement(target)
    if (!element) return

    scrollBelowHeader(element, collapsingHeightAbove(element))
  }

  return { scrollExpandedIntoView, scrollExpandingPlayIntoView }
}
